<template>
  <div class="sub-wrapper">
    <header>
      <icon name="checkbox" />

      <h4>{{ name }}</h4>
    </header>
    <DisplayGridCards :count="options.length">
      <FormFieldButtonSubField
        v-for="option in options"
        :key="option.value"
        :name="option.name"
        :value="option.value"
        :selected="option.selected"
        @select="handleSelect"
      />
    </DisplayGridCards>
  </div>
</template>
<script setup lang="ts">
interface Props {
  id: string;
  field: FormField;
  name: string;
}

const props = defineProps({
  id: null,
  field: null,
  name: null
});

const { formNavigation } = inject(INJECT_FORM_PAGE);

const { onSubmit, onPrevious } = formNavigation;

const emit = defineEmits(["cancel", "save"]);

onSubmit(() => {
  emit('save');
});

onPrevious(() => {
  emit('cancel');
});

const model = defineModel<string[]>('subfieldIds');

const options = computed(() => {
  return props.field.options.map((option) => {
    return {
      ...option,
      selected: selectedIds.value.includes(option.value),
    };
  });
});

const { isMaxChoicesReached, openDialogMaxChoices } = useFormMaxChoices(
  props.field,
  model
);

const selectedIds = computed(() => {
  return (model.value as string[]).map((item) => item);
});

const getSelectedIdIndex = (id) => {
  return model.value.findIndex((value) => value === id);
};

const isIdSelected = (id) => {
  const index = getSelectedIdIndex(id);
  return index > -1;
};

const selectId = (id) => {
  model.value.push(id);
};

const deselectId = (id) => {
  const index = getSelectedIdIndex(id);
  if (index > -1) model.value.splice(index, 1);
};

const toggle = (id) => {
  if (isIdSelected(id)) {
    deselectId(id);
  } else if (!isMaxChoicesReached.value) {
    selectId(id);
  } else {
    openDialogMaxChoices();
  }
};

const handleSelect = (id) => {
  toggle(id);
};

watch(
  () => model.value.length,
  (count) => {
    if (count > 0) {
      formNavigation.lock(1);
    } else {
      formNavigation.lock(2);
    }
  }
);

onMounted(() => {
  formNavigation.lock(2);
});

onUnmounted(() => {
  formNavigation.lock(0);
});
</script>
<style lang="scss" scoped>
header {
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
  padding: 0 3rem;
  gap: var(--gap_n);
  .title {
    padding-bottom: 1rem;
  }

  // padding-bottom: 1rem;
  .icon {
    align-self: stretch;
    margin-left: -2.4rem;
    color: var(--color_primary);
    @include mobile {
      display: none;
    }
  }
  h4 {
    display: inline;
    width: auto;
    text-align: center;
    &::after {
      content: '';
      display: block;
      width: 100%;
      height: 0.2rem;
      border: none;
      background-color: var(--color_primary);
      @include mobile {
        display: none;
      }
    }
  }
}
hr {
  // content: '';
  display: block;

  // position: absolute;
  bottom: 0;
  left: 50%;
  width: 40%;
  height: 0.2rem;
  margin: 0 auto 1rem;
  border: none;
  background-color: var(--color_primary);
}

.sub-wrapper {
  display: flex;
  flex-direction: column;
  gap: var(--gap_m);
}
</style>
